import React from "react";
import { useParams } from "react-router-dom";
import { PageTopbar } from "../../components/Page/Topbar";
import { AppAuthReset } from "../../app/Auth/Reset";

export function RoutesAuthReset({ parents, current }) {

    let { token } = useParams();

    return (
        <>
            <PageTopbar
                parents={parents}
                current={current}
            />
   
            <AppAuthReset token={token}/>
        </>
    );
}